/* eslint-disable react-hooks/exhaustive-deps */
/**
 * B040020 発注照会
 */
import { Column, Query } from "@material-table/core";
import {
  B000170ShireNm,
  B040010Delete,
  B040010DeleteRequest,
  B040020Find,
  B040020FindRequest,
  B040020Get,
  B040020GetCopy,
  B040020GetCopyRequest,
  B040020GetExcel,
  catchFileError,
  catchRestError,
} from "clients/rest";
import {
  msgState,
  SCancelButton,
  SCodeSelect,
  SConfirmDialog,
  SDateField,
  SFileButton,
  SFrame,
  SLabel,
  SNormalButton,
  SNumberField,
  STable,
  SText,
  STextField,
} from "components";
import { getClientMessage } from "messages";
import {
  B040020Shutsuryokujun,
  getSCode,
  HachuKanryoKbn,
  SCode,
} from "messages/codes";
import { labels } from "messages/labels";
import { B000120, B000130, B000140, B000170, B040010InputData } from "pages";
import { createRef, useEffect, useRef, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import {
  atom,
  useRecoilState,
  useRecoilValue,
  useSetRecoilState,
} from "recoil";
import { download, mapIds } from "services";
import { editKbn, eigyoKengen } from "services/codes";
import { date, dateWithSlashAt } from "services/DateService";
import {
  authState,
  focusState,
  menusState,
  navigateTypeState,
  useFocus,
} from "states";

// 呼び出し時のプロパティ
type Props = Partial<{
  // 呼び出し元へデータを送る場合に設定する。
  handleSubmit: (data: any) => void;
}>;

// コンポーネントで設定されるフィールドの型を定義する
type Fields = Partial<{
  hachuYmdFrom: string;
  hachuYmdTo: string;
  nyukayoteiYmdFrom: string;
  nyukayoteiYmdTo: string;
  eigyoCdFrom: string;
  eigyoCdTo: string;
  bumonCdFrom: string;
  bumonCdTo: string;
  shainCdFrom: string;
  shainCdTo: string;
  hachudenpyoNoFrom: string;
  hachudenpyoNoTo: string;
  shireCd: string;
  shireNm: string;
  kanryoKbn: SCode;
  shutsuryokujun: SCode;
}>;

// テーブルデータ定義
type Data = Partial<{
  gyo: number;
  hachuYmd: string;
  nyukayoteiYmd: string;
  hachudenpyoNo: string;
  shireNm: string;
  shainNm: string;
  bumonNm: number;
  hachuKin: string;
  hachuzanKin: string;
  nyukakakuteiKin: number;
  kanryoKbnView: number;
}>;

// フィールドの初期値を設定する。
const defaultFields: Fields = {
  hachuYmdFrom: "",
  hachuYmdTo: "",
  nyukayoteiYmdFrom: "",
  nyukayoteiYmdTo: "",
  eigyoCdFrom: "",
  eigyoCdTo: "",
  bumonCdFrom: "",
  bumonCdTo: "",
  shainCdFrom: "",
  shainCdTo: "",
  hachudenpyoNoFrom: "",
  hachudenpyoNoTo: "",
  shireCd: "",
  shireNm: "",
  kanryoKbn: getSCode(HachuKanryoKbn, "0"),
  shutsuryokujun: getSCode(B040020Shutsuryokujun, "0"),
};

// テーブルを定義する。
const columns: Column<Data>[] = [
  { field: "gyo", title: "行　", width: "4rem", align: "right" },
  {
    field: "hachuYmd",
    title: "発注日",
    width: "6rem",
    render: (data) => {
      if (data.hachuYmd! !== null && data.hachuYmd! !== "") {
        return dateWithSlashAt(data.hachuYmd!);
      }
    },
  },
  {
    field: "nyukayoteiYmd",
    title: "入荷予定日",
    width: "6rem",
    render: (data) => {
      if (data.nyukayoteiYmd! !== null && data.nyukayoteiYmd! !== "") {
        return dateWithSlashAt(data.nyukayoteiYmd!);
      }
    },
  },
  { field: "hachudenpyoNoF", title: "発注No.", width: "6rem" },
  { field: "shireNm", title: "仕入先", width: "15rem" },
  { field: "shainNm", title: "発注担当者", width: "6rem" },
  { field: "bumonNm", title: "発注担当部門", width: "6rem" },
  {
    field: "hachuKin",
    title: "発注金額　",
    width: "5rem",
    align: "right",
    render: (data) => data.hachuKin?.toLocaleString(),
  },
  {
    field: "nyukakakuteiKin",
    title: "入荷済金額　",
    width: "5rem",
    align: "right",
    render: (data) => data.nyukakakuteiKin?.toLocaleString(),
  },
  {
    field: "hachuzanKin",
    title: "発注残金額　",
    width: "5rem",
    align: "right",
    render: (data) => data.hachuzanKin?.toLocaleString(),
  },
  {
    field: "kanryoKbnView",
    title: "完了",
    width: "5rem",
  },
  { field: "hachudenpyoNo", title: "発注No.", hidden: true },
];

// 検索条件を格納するデータタイプ
type SearchedFields = {
  searched: boolean;
} & Partial<{
  fields: Fields;
}>;

// 検索条件を格納するステート
export const B040020State = atom<SearchedFields>({
  key: "B040020State",
  default: {
    searched: false,
    fields: defaultFields,
  },
});

// フォーカスIDの設定
const focusId = "B040020";

export const B040020 = (props: Props) => {
  useFocus(focusId);
  return <Page {...props} />;
};

const Page = (props: Props) => {
  const [searchedFeields, setSearchedFields] = useRecoilState(B040020State);

  // 状態管理の初期設定
  // テーブルの値取得用Ref
  const tableRef = createRef();

  // 初回検索用のフラグ
  const [searched, setSearched] = useState(false);

  // 検索ボタン押下時に初期ページにするステート
  const isDefaultPage = useRef(false);

  // フォーム関数
  const methods = useForm<Fields>({
    mode: "onBlur",
    defaultValues: defaultFields,
  });

  // フォーカス設定
  const { focus, register } = useRecoilValue(focusState(focusId));

  // メッセージ表示
  const setMsg = useSetRecoilState(msgState);

  // 画面遷移の処理
  const navigate = useNavigate();
  const [menuNavigate, setMenuNavigate] = useRecoilState(navigateTypeState);

  // ログインユーザー情報
  const auth = useRecoilValue(authState);
  // 所属営業所コードでの営業所コード入力制御
  const [isEigyoCdHonsha, setIsEigyoCdHonsha] = useState(true);
  // menusステート取得
  const menus = useRecoilValue(menusState);
  // 営業所権限取得
  const eigyosyoKengen = menus["040"].pages["040020"].eigyosyoKengen;

  // 初期表示イベント
  useEffect(() => {
    if (menuNavigate === "menu") {
      // 自営業所の設定
      // イベント利用権限定義マスタ.営業所権限が"0"(所属営業所のみ指定可)の場合、
      if (eigyosyoKengen === eigyoKengen.only) {
        // 自営業所コード(変更不可)の設定
        methods.setValue("eigyoCdFrom", auth?.eigyoCd!);
        methods.setValue("eigyoCdTo", auth?.eigyoCd!);
        // 入力部非活性化
        setIsEigyoCdHonsha(false);
      }
      // 利用権限定義マスタ.営業所権限が"1"(全営業所指定可権限)の場合、
      else if (eigyosyoKengen === eigyoKengen.all) {
        // 空白(入力可能)
        setIsEigyoCdHonsha(true);
      }
      // 初期表示
      (async () => {
        await methods.setValue("hachuYmdFrom", date());
        methods.setValue("hachuYmdTo", date());
        focus(1);
      })();
      return;
    }

    if (searchedFeields.searched) {
      // 検索条件が保存されている
      const fields = searchedFeields.fields;
      if (typeof fields !== "undefined") {
        methods.setValue("hachuYmdFrom", fields.hachuYmdFrom);
        methods.setValue("hachuYmdTo", fields.hachuYmdTo);
        methods.setValue("nyukayoteiYmdFrom", fields.nyukayoteiYmdFrom);
        methods.setValue("nyukayoteiYmdTo", fields.nyukayoteiYmdTo);
        methods.setValue("eigyoCdFrom", fields.eigyoCdFrom);
        methods.setValue("eigyoCdTo", fields.eigyoCdTo);
        methods.setValue("bumonCdFrom", fields.bumonCdFrom);
        methods.setValue("bumonCdTo", fields.bumonCdTo);
        methods.setValue("shainCdFrom", fields.shainCdFrom);
        methods.setValue("shainCdTo", fields.shainCdTo);
        methods.setValue("hachudenpyoNoFrom", fields.hachudenpyoNoFrom);
        methods.setValue("hachudenpyoNoTo", fields.hachudenpyoNoTo);
        methods.setValue("shireCd", fields.shireCd);
        methods.setValue("shireNm", fields.shireNm);
        methods.setValue("kanryoKbn", fields.kanryoKbn);
        methods.setValue("shutsuryokujun", fields.shutsuryokujun);
        setSearched(true);
        return;
      }
    }
  }, []);

  // テーブル行で選択されたデータ
  const [rowData, setRowData] = useState<Partial<Data>>();

  // ボタンの活性・非活性
  const [disabledHachuDelete, setDisabledHachuDelete] = useState(true);
  const [disabledHachuCopy, setDisabledHachuCopy] = useState(true);
  const [disabledHachuDetail, setDisabledHachuDetail] = useState(true);
  const [disabledHachuExcel, setDisabledHachuExcel] = useState(true);

  // テーブル行選択時
  const handleSelectTableRow = (_: any, rowData: Data | undefined) => {
    // 行が選択されていないときはボタン非活性
    const disabled = typeof rowData === "undefined";
    setDisabledHachuDelete(disabled);
    setDisabledHachuCopy(disabled);
    setDisabledHachuDetail(disabled);

    // データを保存
    setRowData(rowData);
  };

  // テーブル行ダブルクリック時・詳細ボタンクリック時
  const handleDoubleClickTableRow = (data: Data) => {
    // 受注データの検索を行う
    B040020Get({ hachudenpyoNo: data.hachudenpyoNo })
      .then((value) => {
        // 確定済・キャンセル済のデータ→参照モード それ以外→編集モード
        const inputData: B040010InputData = {
          editKbn: editKbn.update,
          hachu: value.data,
        };
        setSearchedFields({ searched: true, fields: methods.getValues() });
        // 発注入力画面へ遷移する。
        setMenuNavigate("next");
        navigate("/b040010", { state: inputData });
      })
      .catch((reason) => {
        catchRestError(reason, navigate, setMsg);
      });
  };

  // 詳細ボタンクリック時
  const handleClickShowDetailButton = () => {
    // 行が選択されている場合のみ実行する。
    if (typeof rowData === "undefined") {
      return;
    }

    // 発注データの検索を行う
    B040020Get({ hachudenpyoNo: rowData.hachudenpyoNo })
      .then((value) => {
        const inputData: B040010InputData = {
          editKbn: editKbn.update,
          hachu: value.data,
        };
        setSearchedFields({ searched: true, fields: methods.getValues() });
        // 発注入力画面へ遷移する。
        setMenuNavigate("next");
        navigate("/b040010", { state: inputData });
      })
      .catch((reason) => {
        catchRestError(reason, navigate, setMsg);
      });
  };

  // 複製ボタンクリック時
  const handleClickCopyButton = () => {
    // 行が選択されている場合のみ実行する。
    if (typeof rowData === "undefined") {
      return;
    }

    const param: B040020GetCopyRequest = {
      hachudenpyoNo: rowData.hachudenpyoNo,
    };
    B040020GetCopy(param)
      .then((value) => {
        const inputData: B040010InputData = {
          editKbn: editKbn.register,
          hachu: value.data,
        };
        setSearchedFields({ searched: true, fields: methods.getValues() });
        // 発注入力画面へ遷移する。
        setMenuNavigate("next");
        navigate("/b040010", { state: inputData });
      })
      .catch((reason) => {
        catchRestError(reason, navigate, setMsg);
      });
  };

  // 発注削除イベント
  const handleClickDeleteButton = () => {
    // 行が選択されている場合のみ実行する。
    if (typeof rowData === "undefined") {
      return;
    }
    // リクエスト作成
    const param: B040010DeleteRequest = {
      hachudenpyoNo: rowData.hachudenpyoNo,
    };
    // API呼び出し
    B040010Delete(param)
      .then(() => {
        // 削除後に先頭ページに戻る
        isDefaultPage.current = true;
        // テーブル再検索
        (tableRef.current as any).onQueryChange();
        // 各ボタン非活性化
        setDisabledHachuDelete(true);
        setDisabledHachuCopy(true);
        setDisabledHachuDetail(true);
        // 削除完了メッセージ設定
        setMsg(getClientMessage("B040020_001"));
      })
      .catch((reason) => {
        catchRestError(reason, navigate, setMsg);
      });
  };

  // Excel出力ボタンクリックイベント
  const handleClickExcelButton = () => {
    // 検索フォームのデータを取得する。
    const fields = methods.getValues();

    // 完了区分
    let paramKanryoKbn;
    // 未完了
    if (fields.kanryoKbn?.value! === "0") {
      paramKanryoKbn = fields.kanryoKbn?.value!;
      // 全件
    } else if (fields.kanryoKbn?.value! === "1") {
      paramKanryoKbn = "2";
    }

    // 出力順の値に応じたソート処理
    let order;
    if (fields.shutsuryokujun?.value === "0") {
      order = ["hachuYmd,asc", "hachudenpyoNo,asc"];
    } else if (fields.shutsuryokujun?.value === "1") {
      order = ["nyukayoteiYmd,asc", "hachudenpyoNo,asc"];
    } else if (fields.shutsuryokujun?.value === "2") {
      order = ["shireCd,asc", "hachudenpyoNo,asc"];
    } else if (fields.shutsuryokujun?.value === "3") {
      order = ["hachudenpyoNo,asc"];
    }

    // Excel出力パラメータを作成する。
    const param: B040020FindRequest = {
      kanryoKbn: paramKanryoKbn,
      hachuYmdFrom: fields.hachuYmdFrom,
      hachuYmdTo: fields.hachuYmdTo,
      nyukayoteiYmdFrom: fields.nyukayoteiYmdFrom,
      nyukayoteiYmdTo: fields.nyukayoteiYmdTo,
      eigyoCdFrom: fields.eigyoCdFrom,
      eigyoCdTo: fields.eigyoCdTo,
      bumonCdFrom: fields.bumonCdFrom,
      bumonCdTo: fields.bumonCdTo,
      shainCdFrom: fields.shainCdFrom,
      shainCdTo: fields.shainCdTo,
      hachudenpyoNoFrom: fields.hachudenpyoNoFrom,
      hachudenpyoNoTo: fields.hachudenpyoNoTo,
      shireCd: fields.shireCd,
      sort: order,
    };
    // API呼び出し
    B040020GetExcel(param)
      .then((response) => {
        download(response);
        setMsg(getClientMessage("B040020_002"));
      })
      .catch((reason) => {
        catchFileError(reason, navigate, setMsg);
      });
  };

  // 検索時の初期化処理
  const handleResetSearch = () => {
    // ボタン非活性化
    setDisabledHachuDelete(true);
    setDisabledHachuCopy(true);
    setDisabledHachuDetail(true);
    // 選択されているデータを空にする
    setRowData({});
    (tableRef.current as any).handleClearSelect();
  };

  // 検索ボタンクリックイベント
  const handleClickSearchButton = () => {
    // 初期化
    handleResetSearch();
    // excelボタン非活性化
    setDisabledHachuExcel(true);
    // 検索可能に変更
    setSearched(true);
    // 初期ページ設定
    isDefaultPage.current = true;
    // テーブル再検索
    (tableRef.current as any).onQueryChange();
  };

  // 検索イベント
  const handleSearch = (query: Query<Data>) => {
    return new Promise<any>((resolve) => {
      // 初回検索をしない
      if (!searched) {
        resolve({
          data: [],
          page: 0,
          totalCount: 0,
        });
        return;
      }

      // 検索フォームのデータを取得する。
      const fields = methods.getValues();

      // 完了区分
      let paramKanryoKbn;
      // 未完了
      if (fields.kanryoKbn?.value! === "0") {
        paramKanryoKbn = fields.kanryoKbn?.value!;
        // 全件
      } else if (fields.kanryoKbn?.value! === "1") {
        paramKanryoKbn = "2";
      }

      // 出力順の値に応じたソート処理
      let order;
      if (fields.shutsuryokujun?.value === "0") {
        order = ["hachuYmd,asc", "hachudenpyoNo,asc"];
      } else if (fields.shutsuryokujun?.value === "1") {
        order = ["nyukayoteiYmd,asc", "hachudenpyoNo,asc"];
      } else if (fields.shutsuryokujun?.value === "2") {
        order = ["shireCd,asc", "hachudenpyoNo,asc"];
      } else if (fields.shutsuryokujun?.value === "3") {
        order = ["hachudenpyoNo,asc"];
      }

      // 初期ページ表示の場合、0を設定する。
      query.page = isDefaultPage.current ? 0 : query.page;

      // 検索パラメータを作成する。
      const param: B040020FindRequest = {
        kanryoKbn: paramKanryoKbn,
        hachuYmdFrom: fields.hachuYmdFrom,
        hachuYmdTo: fields.hachuYmdTo,
        nyukayoteiYmdFrom: fields.nyukayoteiYmdFrom,
        nyukayoteiYmdTo: fields.nyukayoteiYmdTo,
        eigyoCdFrom: fields.eigyoCdFrom,
        eigyoCdTo: fields.eigyoCdTo,
        bumonCdFrom: fields.bumonCdFrom,
        bumonCdTo: fields.bumonCdTo,
        shainCdFrom: fields.shainCdFrom,
        shainCdTo: fields.shainCdTo,
        hachudenpyoNoFrom: fields.hachudenpyoNoFrom,
        hachudenpyoNoTo: fields.hachudenpyoNoTo,
        shireCd: fields.shireCd,
        // ページネーションの設定
        page: query.page,
        size: query.pageSize,
        // ソートの設定
        sort: order,
      };
      // API呼び出し
      B040020Find(param)
        // 正常取得時
        .then((value) => {
          const offset = query.pageSize * query.page;
          resolve({
            data: mapIds(value.data.content, "gyo", offset),
            page: value.data.number,
            totalCount: value.data.totalElements,
          });
          // Excel出力ボタン活性化
          setDisabledHachuExcel(value.data.content.length <= 0);
        })
        // エラー時
        .catch((reason) => {
          catchRestError(reason, navigate, setMsg);
          resolve({
            data: [],
            page: 0,
            totalCount: 0,
          });
        })
        .finally(() => {
          // 初期ページ表示をオフにする。
          isDefaultPage.current = false;
        });
    });
  };

  // レイアウト設定
  return (
    <FormProvider {...methods}>
      <SFrame
        title="発注照会"
        gridTemplateColumns="6rem 9rem 1rem 10rem 1rem 6rem 9rem 1rem 9rem"
      >
        <SLabel>発注日</SLabel>
        <SDateField name="hachuYmdFrom" {...register(1)} />
        <SText>～</SText>
        <SDateField name="hachuYmdTo" {...register(2)} />
        <SLabel gridColumn="6">入荷予定日</SLabel>
        <SDateField name="nyukayoteiYmdFrom" {...register(3)} />
        <SText>～</SText>
        <SDateField name="nyukayoteiYmdTo" {...register(4)} />
        <SLabel gridColumn="1">営業所</SLabel>
        {isEigyoCdHonsha ? (
          <STextField
            code
            label="営業所コード（開始）"
            name="eigyoCdFrom"
            {...register(5)}
            size={6}
            dialog={<B000120 />}
            handleSubmit={(data: any) => {
              methods.setValue("eigyoCdFrom", data.eigyoCd);
            }}
          />
        ) : (
          <STextField
            label="営業所コード（開始）"
            name="eigyoCdFrom"
            disabled
          />
        )}
        <SText>～</SText>
        {isEigyoCdHonsha ? (
          <STextField
            code
            label="営業所コード（終了）"
            name="eigyoCdTo"
            {...register(6)}
            size={6}
            dialog={<B000120 />}
            handleSubmit={(data: any) => {
              methods.setValue("eigyoCdTo", data.eigyoCd);
            }}
          />
        ) : (
          <STextField label="営業所コード（終了）" name="eigyoCdTo" disabled />
        )}
        <SLabel gridColumn="1">発注担当部門</SLabel>
        <STextField
          name="bumonCdFrom"
          code
          size={6}
          {...register(7)}
          dialog={<B000130 />}
          handleSubmit={(data: any) => {
            methods.setValue("bumonCdFrom", data.bumonCd);
          }}
        />
        <SText>～</SText>
        <STextField
          name="bumonCdTo"
          code
          size={6}
          {...register(8)}
          dialog={<B000130 />}
          handleSubmit={(data: any) => {
            methods.setValue("bumonCdTo", data.bumonCd);
          }}
        />
        <SLabel gridColumn="6">発注担当者</SLabel>
        <STextField
          name="shainCdFrom"
          code
          size={7}
          {...register(9)}
          dialog={<B000140 />}
          handleSubmit={(data: any) => {
            methods.setValue("shainCdFrom", data.shainCd);
          }}
        />
        <SText>～</SText>
        <STextField
          name="shainCdTo"
          code
          size={7}
          {...register(10)}
          dialog={<B000140 />}
          handleSubmit={(data: any) => {
            methods.setValue("shainCdTo", data.shainCd);
          }}
        />
        <SLabel gridColumn="1">発注No.</SLabel>
        <SNumberField
          name="hachudenpyoNoFrom"
          code
          size={10}
          {...register(11)}
        />
        <SText>～</SText>
        <SNumberField name="hachudenpyoNoTo" code size={10} {...register(12)} />
        <SLabel gridColumn="1">仕入先</SLabel>
        <SNumberField
          name="shireCd"
          code
          size={6}
          {...register(13)}
          onBlur={() => B000170ShireNm(methods, navigate, setMsg)}
          dialog={<B000170 />}
          handleSubmit={(data: any) => {
            methods.setValue("shireCd", data.shireCd);
            methods.setValue("shireNm", data.shireNmr);
          }}
        />
        <STextField name="shireNm" size={24} disabled gridColumn="span 2" />
        <SLabel gridColumn="1">完了</SLabel>
        <SCodeSelect
          name="kanryoKbn"
          options={HachuKanryoKbn}
          {...register(14)}
        />
        <SLabel gridColumn="6">出力順</SLabel>
        <SCodeSelect
          name="shutsuryokujun"
          options={B040020Shutsuryokujun}
          {...register(15)}
        />
        <SNormalButton
          label={labels.buttons.search}
          onClick={handleClickSearchButton}
          gridRow={7}
          gridColumn={9}
          {...register(16)}
          align="right"
        />
      </SFrame>
      <SFrame>
        <SText></SText>
        <STable
          keyName="gyo"
          data={handleSearch}
          columns={columns}
          tableRef={tableRef}
          handleDoubleClick={handleDoubleClickTableRow}
          onRowClick={handleSelectTableRow}
          width={1270}
          height={300}
          onPageChange={handleResetSearch}
        />
      </SFrame>
      <SFrame gridTemplateColumns="7rem 58.4rem 4rem 0.5rem 4rem 0.5rem 5rem">
        {" "}
        <SCancelButton
          label={labels.buttons.delete}
          gridColumn={1}
          {...register(20)}
          disabled={disabledHachuDelete}
          dialog={
            <SConfirmDialog
              title="発注データ削除"
              msg="選択中の発注データを削除します。よろしいですか？"
            />
          }
          dialogAction="confirm"
          handleSubmit={handleClickDeleteButton}
        />
        <SNormalButton
          label={labels.buttons.copy}
          gridColumn={3}
          {...register(17)}
          onClick={handleClickCopyButton}
          disabled={disabledHachuCopy}
          dialogAction="close"
          align="right"
        />
        <SNormalButton
          label={labels.buttons.detail}
          gridColumn={5}
          {...register(18)}
          onClick={handleClickShowDetailButton}
          disabled={disabledHachuDetail}
          align="right"
        />
        <SFileButton
          label={labels.buttons.excel}
          onClick={handleClickExcelButton}
          disabled={disabledHachuExcel}
          {...register(19)}
          gridColumn={7}
        />
      </SFrame>
    </FormProvider>
  );
};
